import { WRENCH_MODE_EVENTS_CRUD_ACTION_CREATORS } from '../actions/wrench_mode_events_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { nullSafeGetOrElse } from '../utils/DataAccessUtils';

export const wrenchModeEventsRestCrudThunksForSupplier = new RestCrudThunks(
	'events',
	'event',
	'event',
	'events',
	WRENCH_MODE_EVENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'wrench_mode/'
);

export interface WrenchHubUserAnalytic {
	supplierEmail: string;
	driveTimeMs: number;
	workTimeMs: number;
	totalTimeMs: number;
}

const fetchUtils = new FetchUtils();

export const fetchWrenchHubUserAnalyticsForSupplier = (
	fromDate: string,
	toDate: string,
	supervisorEmail?: string
): Promise<WrenchHubUserAnalytic[]> => {
	const supervisorQuery = supervisorEmail
		? `?supervisorEmail=${encodeURIComponent(supervisorEmail)}`
		: '';
	const queryUri = `${getBackendUri()}/api/v1/supplier/wrench_mode/events/analytics/${fromDate}/${toDate}${supervisorQuery}`;

	return fetchUtils
		.get(queryUri, {
			headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		})
		.then(parseJSON)
		.then(({ json, ok }) => {
			const d = json;
			if (!ok || d.status === 'error') {
				throw new Error(d.message || 'Failed to fetch wrench hub user analytics');
			}
			return d.data || [];
		});
};

export interface DriveTimeRetime {
	id: number;
	// UTC ISO-8601 instant for the event's new timestamp.
	createdAt: string;
}

/**
 * Retime a visit's drive-boundary events (began_trip / arrived) so the derived drive time in
 * WrenchMode Work Logs can be corrected. Posts a bare array of { id, createdAt } to the supplier
 * revise_drive_time endpoint. Resolves with the updated events, rejects with a message string.
 */
export const reviseDriveTimeForSupplier = (retimes: DriveTimeRetime[]) => () =>
	new Promise((resolve, reject) => {
		fetchUtils
			.put(`${getBackendUri()}/api/v1/supplier/wrench_mode/events/revise_drive_time`, {
				data: retimes,
			})
			.then(parseJSON)
			.then(({ ok, json }) => {
				// Treat a 2xx that still carries the API's error envelope as a failure, matching the
				// sibling thunk / CRUD generator, so a rejected retime never shows as success.
				if (ok && nullSafeGetOrElse('status', json, '') !== 'error') {
					resolve(nullSafeGetOrElse('data', json, []));
				} else {
					reject(nullSafeGetOrElse('message', json, 'Failed to update drive time.'));
				}
			})
			.catch(() => reject('Failed to update drive time.'));
	});
